import { FC, PropsWithChildren, useState } from 'react';
import {
  DataManagementContext,
  defaultDataManagementContext,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/DataManagementContext';
import {
  BrandAffinityInsightData,
  Timespan,
} from 'modules/intelligentInsights/brandAffinityInsights/types';
import { TimespanEnum } from 'modules/intelligentInsights/types';
import {
  getAffinityBreakdownCSVData,
  historyCSVDataCreator,
  parseCoreInsightsData,
} from 'modules/intelligentInsights/brandAffinityInsights/contexts/dataManagement/dataManagement.utils';

export interface DataManagementProviderProps extends PropsWithChildren {
  coreData: BrandAffinityInsightData;
  isLoadingData: boolean;
  fetchCoreData: (nextTimespan: Timespan) => void;
}

export const DataManagementProvider: FC<DataManagementProviderProps> = ({
  children,
  coreData,
  fetchCoreData,
  isLoadingData,
}) => {
  const [selectedTimespan, setTimespan] = useState(TimespanEnum.Thirty);
  const parsedInsightsData = parseCoreInsightsData(coreData, selectedTimespan);

  return (
    <DataManagementContext.Provider
      value={{
        managedInsightsData: isLoadingData
          ? defaultDataManagementContext.managedInsightsData
          : parsedInsightsData,
        timeSpan: {
          selectedTimespan,
          updateTimespan: (requestedTimespan: Timespan) => {
            setTimespan(requestedTimespan);
            fetchCoreData(requestedTimespan);
          },
        },
        getHistoryCSVData: historyCSVDataCreator(parsedInsightsData.history),
        affinityBreakdownCSVData: getAffinityBreakdownCSVData(parsedInsightsData),
      }}
    >
      {children}
    </DataManagementContext.Provider>
  );
};
